// extracted by mini-css-extract-plugin
export default {"relateShortRecom":"index_relateShortRecom_-sDUS","shortAppTxt":"index_shortAppTxt_ZWSBB","boxBottomLine":"index_boxBottomLine_D6MrZ"};